import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';

// 1. The Animation: Makes the letters "float" up and down continuously
const float = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-15px); // Moves 15px up
  }
`;

// 2. Container to center the title on the page and add breathing room
const HeroContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  min-height: 18vh; // Adjust this based on where you place it (e.g., 100vh for full hero)
  width: 100%;
  padding-top: 30px;
  background-color: #f9fafb; // Light background to make colors pop
// background:red;
  `;

// 3. The main H1 tag
const MainTitle = styled.h1`
  font-size: 64px; // Large, impactful size
  font-weight: 900; // Extra bold
  font-family: 'Comic Sans MS', 'Chalkboard SE', 'Comic Neue', sans-serif; // Playful fallback fonts
  text-align: center;
  margin: 0;
  display: flex; // Needed to apply animation delay to individual letters
  flex-wrap: wrap; // Allows wrapping on very small screens
  justify-content: center;
  text-shadow: 2px 2px 0px rgba(0, 0, 0, 0.1); // Soft shadow for depth

  // Media query for tablets/mobile
  @media (max-width: 768px) {
    font-size: 42px;
  }
`;

// 4. Wrapper for each letter to apply animation and individual colors
const AnimatedLetter = styled.span`
  display: inline-block;
  animation: ${float} 2.5s ease-in-out infinite;
  
  // Apply specific colors based on the word grouping
  color: ${props => props.color};
  
  // Add a slight delay to each letter based on its index for a wave effect
  animation-delay: ${props => props.delay}s;

  // Optional: Add a little wiggle on hover for fun
  &:hover {
    animation: ${float} 0.3s ease infinite;
  }
`;

const NavSubMenu = styled.nav`
  background: #f8f9fa;
  border-bottom: 1px solid #e5e7eb;
  padding: 4px 5px;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  justify-content: center;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 5;
`;

const NavCategory = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #4f46e5;
`;

const NavLink = styled.a`
  color: #374151;
  color: white;
  text-decoration: none;
  font-size: 12px;
  font-weight: bold;
  padding: 4px 8px;
  border-radius: 4px;
  background: ${props => props.active ? 'orange' : '#4f46e5'};
  border: 1px solid #e5e7eb;
  transition: all 0.2s ease;
  border-radius: 10px;

  &:hover {
    background: orange;
    color: #ffffff;
  }
`;

// Helper component to split text into letters and apply animation delays
const WavyText = ({ text, colors }) => {
  // Flatten colors array to correspond to each letter (excluding spaces)
  let letterIndex = 0;
  
  return (
    <>
      {text.split("").map((char, index) => {
        if (char === " ") {
          return <span key={index}>&nbsp;</span>;
        }
        
        // Determine color based on current letter index
        const color = colors[letterIndex % colors.length];
        
        // Increment index for next letter
        letterIndex++;

        // Return letter with animation delay (staggered by 0.05s)
        return (
          <AnimatedLetter 
            key={index} 
            color={color}
            delay={index * 0.08}
          >
            {char}
          </AnimatedLetter>
        );
      })}
    </>
  );
};

// 5. Final Export Component
const KidsCodePageHero = () => {
    const navigate = useNavigate();
    const location = useLocation();
  // Define color palettes for each word
  // Word 1 (KIDS): Vibrant Kids
  const kidsColors = ['#FF6B6B', '#FFD93D', '#4FD1C5', '#6366F1']; 
  // Word 2 (CODE): Tech Blues/Greens
  const codeColors = ['#3B82F6', '#06B6D4', '#10B981', '#84CC16'];
  // Word 3 (TECH): Warm/FunPinks/Oranges
  const techColors = ['#F472B6', '#EC4899', '#F97316', '#FBBF24'];



  return (
    <>
     <HeroContainer>
      <MainTitle>
        {/* Apply different color sets to distinct parts of the title */}
        <WavyText text="KIDS" colors={kidsColors} />
        &nbsp;
        <WavyText text="CODE" colors={codeColors} />
        &nbsp;
        <WavyText text="AND" colors={kidsColors} /> {/* Reusing bright colors for 'AND' */}
        &nbsp;
        <WavyText text="TECH" colors={techColors} />
      </MainTitle>
      
    </HeroContainer>
<NavSubMenu>
        <NavLink 
          href="/kidscodeandtech" 
          active={location.pathname === '/kidscodeandtech'}
        >
          Kids Online Coding
        </NavLink>
        
        <NavLink 
          href="/summercoding" 
          active={location.pathname === '/summercoding'}
        >
          Summer Coding & AI
        </NavLink>
        
        <NavLink 
          href="/eastercoding" 
          active={location.pathname === '/eastercoding'}
        >
          Easter Coding & AI
        </NavLink>

        {/* <NavLink 
          href="/summerai" 
          active={location.pathname === '/summerai'}
        >
          Summer AI for Kids
        </NavLink> */}
        
        {/* <NavLink 
          href="/easterai" 
          active={location.pathname === '/easterai'}
        >
          Easter AI for Kids
        </NavLink> */}
        
        <NavLink 
          href="/weekendcoding" 
          active={location.pathname === '/weekendcoding'}
        >
          Weekend Coding & AI
        </NavLink>

             <NavLink 
  href="https://meet.google.com/dfv-bbpz-zaa" 
  target="_blank" 
  rel="noopener noreferrer"
>
  Enter Class Room
</NavLink>
      </NavSubMenu>
    </>
   
  );
};

export default KidsCodePageHero;